
import React from 'react';
import { BookingDetails } from "@/hooks/bookings/types";
import PaymentConfirmationSection from "./PaymentConfirmationSection";
import BookingContactCard from "./BookingContactCard";
import BookingParcelOverviewCard from "./BookingParcelOverviewCard";
import BookingParcelCard from "./BookingParcelCard";
import BookingDateCard from "./BookingDateCard";
import FulfillmentCard from "./FulfillmentCard";

interface BookingViewTabProps {
  booking: BookingDetails;
  quotes: any[];
  onQuoteUpdate: () => Promise<void>;
  onBookingUpdate?: (bookingId: string) => Promise<void>;
  isAdmin: boolean;
  isBookingOwner: boolean;
  showQuotes?: boolean;
}

const BookingViewTab: React.FC<BookingViewTabProps> = ({
  booking,
  quotes,
  onQuoteUpdate,
  onBookingUpdate,
  isAdmin,
  isBookingOwner,
  showQuotes = true
}) => {
  // Debug logging
  console.log('BookingViewTab - booking.fulfillment_details:', booking.fulfillment_details);
  
  return (
    <div className="space-y-8 px-4 pb-6">
      {/* Payment Confirmation Section */}
      <PaymentConfirmationSection 
        paymentConfirmed={booking.payment_confirmed} 
        paymentConfirmedAt={booking.payment_confirmed_at} 
        paymentConfirmedBy={booking.payment_confirmed_by} 
        isAdmin={isAdmin}
      />

      {/* 1. Overview Section */}
      <div className="space-y-4">
        <h2 className="text-xl font-semibold text-foreground">Overview</h2>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          <div className="lg:col-span-1">
            <BookingDateCard date={booking.collection_datetime} />
          </div>
          <div className="lg:col-span-2">
            <BookingParcelOverviewCard 
              parcels={booking.parcels || []} 
              totalParcelsCount={booking.total_parcels_count} 
            />
          </div>
        </div>
        <FulfillmentCard
          fulfillmentDetails={booking.fulfillment_details}
          bookingId={booking.id}
          isAdmin={isAdmin}
          onUpdate={onBookingUpdate ? () => onBookingUpdate(booking.id) : async () => {}}
        />
      </div>

      {/* 2. Address & Contacts Section */}
      <div className="space-y-4">
        <h2 className="text-xl font-semibold text-foreground">Address & Contacts</h2>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <BookingContactCard 
            type="Collection" 
            contacts={booking.collection_contacts || []} 
            address={booking.collection_address} 
          />
          <BookingContactCard 
            type="Delivery" 
            contacts={booking.delivery_contacts || []} 
            address={booking.delivery_address} 
          />
        </div>
      </div>

      {/* 3. Parcel Details Section */}
      {booking.parcels && booking.parcels.length > 0 && (
        <div className="space-y-4">
          <h2 className="text-xl font-semibold text-foreground">Parcel Details</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {booking.parcels.map((parcel, index) => (
              <BookingParcelCard key={parcel.id} parcel={parcel} index={index} />
            ))}
          </div>
        </div>
      )}

    </div>
  );
};

export default BookingViewTab;
